
import { Observable, Subject } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Color } from 'src/app/model/color';
import { Depto } from 'src/app/model/depto';
import { Muni } from 'src/app/model/muni';
import { Sucursal } from 'src/app/model/sucursal';
const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  @Injectable({
    providedIn: 'root'
  })
  export class SucursalService {
    private url : string = `${environment.HOST}/api/`;


    constructor(
        private http : HttpClient,
        private router : Router
      ) { }

   

      


 getSucursal():Observable<Sucursal[]>{
    return this.http.get<Sucursal[]>(`${this.url}sucursal`);
 }



}